/** Error prefix used in all SVGPathCommander TypeError messages. */
export const error = "SVGPathCommanderError";
